"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderedEnumerable = void 0;
const BasicEnumerable_1 = require("./BasicEnumerable");
const applyThenBy_1 = require("../functions/applicators/applyThenBy");
/**
 * Represents a sorted sequence.
 * @typeparam TSource The type of the elements of the sequence.
 */
class OrderedEnumerable extends BasicEnumerable_1.BasicEnumerable {
    constructor(factory, orderedPairs) {
        super(factory, function* () {
            for (const pair of orderedPairs()) {
                yield* pair;
            }
        });
        this.orderedPairs = orderedPairs;
    }
    thenBy(keySelector, comparer) {
        return (0, applyThenBy_1.applyThenBy)(this.factory, this.orderedPairs, true, keySelector, comparer);
    }
    thenByDescending(keySelector, comparer) {
        return (0, applyThenBy_1.applyThenBy)(this.factory, this.orderedPairs, false, keySelector, comparer);
    }
}
exports.OrderedEnumerable = OrderedEnumerable;
//# sourceMappingURL=OrderedEnumerable.js.map